import NavBarContainer from 'views/molecules/navbar/NavbarContainer';

export default NavBarContainer;
